import { NoteInfoInput, ObjectiveTemplateDto } from '../../../types'
import { UseFormReturn, FieldError } from 'react-hook-form'

export enum TargetTemplateModalType {
  newTarget = 'newTarget',
  editTarget = 'editTarget',
  unknown = 'unknow',
}

export interface NoteInfoInputExtended extends NoteInfoInput {
  isNewComment?: boolean
}

export interface TargetTemplateModalFormErrors {
  objective: FieldError | undefined
  objectiveKeyResults?: Array<{
    text: FieldError | undefined
  }>
}

export interface TargetTemplateModalState {
  isTargetTemplateModalOpened: boolean
  targetTemplateModalType: TargetTemplateModalType
  currentObjective: ObjectiveTemplateDto | null
  currentComments: Array<NoteInfoInputExtended>
  commentFromInput: string | undefined
  newTargetTemplateForm: UseFormReturn<ObjectiveTemplateDto> | null
  newTargetTemplateFormErrors: TargetTemplateModalFormErrors | null

  openTargetTemplateModal: (targetTemplateModalType: TargetTemplateModalType, objective?: ObjectiveTemplateDto) => void
  closeTargetTemplateModal: () => void
  cleanTargetTemplateModal: () => void
  addComment: (comment: NoteInfoInputExtended) => void
  setCommentFromInput: (commentFromInput: string | undefined) => void
  removeComment: (id: string, isNewComment?: boolean) => void
  editComment: (id: string, text: string) => void
  setNewTargetTemplateForm: (newTargetTemplateForm: UseFormReturn<ObjectiveTemplateDto>) => void
}
